module.exports = __webpack_public_path__ + "img/消费券头图.c7f2ea1c.png";